import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
import {doc} from './documentation.js';
import {getSlicedParameters} from './params.js';
import {sliceParams} from './params.js';
import {lazy} from './lazy.js';
import {randomize} from '../randomize.js';

export const execute = (script, coords, ...args) => {
    let x = script(coords, ...args);
    return x;
};

doc(
    "random",
    {
        amount: "The degree of randomness"
    },
    "Randomizes the parameter values by ratio passed as an argument (0-1)"
);
export const random = (degree) => {
    let slicer = sliceParams();
    return (coords, ...args) => {
        let slicedCoords = getSlicedParameters(slicer, coords, args);
        coords = slicedCoords;
        let _coords = {};
        let _degree = lazy(degree, ...args);
        for (let key in coords) {
            if (!coords[key]) {
                continue;
            }
            let {x,y} = coords[key];
            _coords[key] = {
                x : randomize(x, 0, WIDTH, _degree),
                y : randomize(y, 0, HEIGHT, _degree),
                density: 1
            };
        }
        return _coords;
    };
};

// partitions group and applys different funcs to each partitions
doc(
    "part",
    {
        "...list": "List of functions that will each get a partition"
    },
    "Partitions the parameters, and executes different functions (the passed args) on each part");
export const part = (... list) => {
    return (coords, ...args) => {
        let partitions = partition(coords, list.length);
        let output = {};
        let i=0;
        for (let _partition of partitions) {
            output = {
                ... output,
                ... list[i](_partition, ...args)
            };
            i++;
        }
        return output;
    };
};

const partition = (coords, num) => {
    let keys = Object.keys(coords);
    let partitionSize = Math.floor(keys.length / num);
    let partitions = [];
    for (let i=0; i < num; i++) {
        let partitionKeys = keys.slice(i * partitionSize, (i+1) * partitionSize);
        let partition = {};
        partitionKeys.forEach(
            key => partition[key] = coords[key]);
        partitions.push(partition);
    }
    return partitions;
};

doc(
    "s",
    {
        "...list": "List of functions to execute"
    },
    "Executes the arguments sequentially, passing the transformed parameter values to each subsequent call");
export const s = (... list) => {
    return (coords, ...args) =>
        {
            for (let l of list) {
                coords = l(coords, ...args);
            }
            return coords;
        };
};

doc(
    "p",
    {
        "...list": "List of functions to execute in parallel"
    },
    "Executes the arguments in parallel, passing the transformed parameter values to each subsequent call");
export const p = (... list) => {
    return (coords, ...args) =>
        {
            let _coords = {};
            for (let l of list) {
                _coords = {
                    ... _coords,
                    ... l(coords, ...args)
                };
            }
            return _coords;
        };
};

